export default __webpack_public_path__ + "1bbee3bd1bc00c4dce2a7c7046930ae6.woff2";